const textareaSelectors = {
    textarea: ".js-textarea",
    number: ".js-textarea-num"
};

(function () {
    const textarea = document.querySelector(textareaSelectors.textarea);
    const number = document.querySelector(textareaSelectors.number);

    if (!number) {
        return null;
    }

    if (!textarea) {
        return null;
    }

    number.textContent = textarea.getAttribute("maxlength");

    textarea.addEventListener("input", ({ currentTarget: target }) => {
        const maxLength = target.getAttribute("maxlength");
        const currentLength = target.value.length;
        number.textContent = maxLength - currentLength;
    });
})();
